import {Component, OnInit, OnDestroy} from '@angular/core';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {SettingsService} from '../../pages-services/';

import {ConfigurationService} from '../../pages-services';
import {timer} from 'rxjs/observable/timer';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs'

@Component({
  selector: 'app-import-button',
  templateUrl: 'import-button.component.html',
  styleUrls: ['import-button.component.scss']
})
export class ImportButtonComponent implements OnInit, OnDestroy {
    isUploading;

    requestStatus$: Observable<number>;
    timeInterval: number = 20000;
    sub: Subscription;
    publishInProcess = '';
    defaultVariants = [];

    constructor(private toasterService: ToasterService,
                private translateService: TranslateService,
                private settingsService: SettingsService,
                private configurationService: ConfigurationService) {
    }

    startInterval() {
      this.requestStatus$ = timer(0, this.timeInterval).pipe();
      this.sub = this.requestStatus$.subscribe((data) => {
        this.checkStatus();
      });
    }

    checkStatus() {
      this.settingsService.loadPublishVersionsList().subscribe((data) => {
        this.publishInProcess = data.publishInProcess;
        this.isUploading = this.publishInProcess !== "";
      });

    }

    ngOnDestroy() {
      if (this.sub) {
        this.sub.unsubscribe();
      }
    }

    ngOnInit() {
      this.startInterval();
    }

    fileUpload({target}) {
      this.isUploading = true;
      const fileField = target;
      const file = fileField.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        const result = JSON.parse(reader.result);
        this.handleProduct(result);
        // this.setDefaultVariants(result);
        // console.log('result', result.settings.products);
        // return false;
        this.configurationService.uploadImport(result).subscribe(async response => {
            this.isUploading = false;
            if (response.success) {
              const successMessage = await this.translateService.get('webpanel.products.import.success_start').toPromise();
              this.toasterService.pop('success', '', successMessage);
              this.isUploading = true;
            } else {
              const errorMessage = await this.translateService.get('webpanel.products.import.error_message').toPromise();
              this.toasterService.pop('error', '', errorMessage);
            }
            fileField.value = '';
          },
          (err) => {
            console.log(err);
            this.isUploading = false;
          });
      };
      reader.readAsText(file);
    }

    handleProduct(product) {
      if (product && product.settings) {
          product.settings.products.forEach(p => {
          const clear_product = JSON.parse(JSON.stringify(p));
          p.categories.forEach(c => {
            c.subcategories.forEach(s => {
              s.variants = this.handleVariants(clear_product, s.variants, s.id);
            })
          })
        })
      }
    }

    handleVariants(product, vrnts, sId) {
      let fullVariants = vrnts.map(vs => {
        const variants = [];
        let count = 1;
        if (vs.id.includes('{') && vs.id.includes('}')) {
          const dependencies = vs.dependencies.map(d => {
            if (typeof d === 'string') {
              count = count * this.findDependence(product, d, d === 'axle-configurations' ? 'groups' : null, sId).length;
              return {[d]: (this.findDependence(product, d, d === 'axle-configurations' ? 'groups' : null, sId))}
            } else {
              return d
            }
          })
          for (let i = 0; i < count; i++) {
            const variant = JSON.parse(JSON.stringify(vs));
            variants.push(variant);
          }
          let amount = 1
          dependencies.forEach(d => {
            vs = this.fillVariants(variants, d, amount, sId);
            amount = amount * d[Object.keys(d)[0]].length;
          })
          vs.map(v => {
            v.id = v.id.replace(`{name}`, v.name);
            v.views.map(vw => vw.layerUrl = vw.layerUrl.replaceAll(`{name}`, v.name)
            );
            return v;
          });
        }
        return vs
      })
      return fullVariants.flat();
    }

    fillVariants(variants, d, amount, sId) {
      const step = amount;
      const key = Object.keys(d)
      let j = 0;
      variants.forEach((v, i) => {
        if (j === d[key[0]].length) {
          j = 0
        }
        v.dependencies = v.dependencies.map(vd => vd === key[0] ?
          vd === 'axle-configurations' ?
            {subcategory: vd, group: d[key[0]][j].id} :
            {subcategory: vd, variant: d[key[0]][j].name}
          : vd);
        switch (key[0]) {
          case 'cabs-ext':
            v.id = v.id.replace(`{${key[0]}}`,
              (sId === 'axle-configurations' || sId === 'trim-levels-ext' || sId === 'engine' || sId === 'transmission') ?
                d[key[0]][j].name.split('-')[1] : d[key[0]][j].name
            );
            v.views.map(vw => vw.layerUrl = vw.layerUrl.replaceAll(`{${key[0]}}`,
              sId === 'trim-levels-ext' ?
                (
                  (v.name === 'extl-sturdy-fh' && d[key[0]][j].name === 'cab-xxl') ? '-xxl' :
                    ['cab-lslp', 'cab-lday'].includes(d[key[0]][j].name) ? '-lslp' : ''
                ) :
                (sId === 'engine' || sId === 'transmission' || sId === 'chairs') && ['lslp', 'slp', 'hslp'].includes(d[key[0]][j].name.split('-')[1]) ? 'slp' :
                  (sId === 'engine' || sId === 'transmission' || sId === 'chairs') && ['day', 'lday'].includes(d[key[0]][j].name.split('-')[1]) ? 'day' :
                    d[key[0]][j].name
            ));
            break;
          default:
            v.id = v.id.replace(`{${key[0]}}`, d[key[0]][j].id);
            v.views.map(vw => vw.layerUrl = vw.layerUrl.replaceAll(`{${key[0]}}`, d[key[0]][j].id)
            );
        }
        if (i >= amount - 1) {
          j++;
          amount = amount + step;
        }
      });
      return variants;
    }

    setDefaultVariants(data) {
      if (data && data.settings) {
        data.settings.products.forEach(p => {
          let str = p.productSettings.filter(ps => ps.key === "default_variants").length > 0 ? p.productSettings.filter(ps => ps.key === "default_variants")[0].value : '';
          this.defaultVariants = str.split(',');
          this.defaultVariants = this.defaultVariants.map(dv => dv.trim());
          p.categories.forEach(c => {
            c.subcategories.forEach(s => {
              s.variants[0].default = true;
              s.variants.map(v => {
                  if(this.defaultVariants.includes(v.id)) {
                    s.variants[0].default = false;
                    v.default = true;
                  }
                  return v;
              });
            })
          })
        })
      }

    }

    findDependence(product, key, g = null, sId) {
      const activeCat = product.categories.find(c => {
        return c.subcategories.find(s => s.id === key)
      })
      if (g === 'groups') {
        return activeCat.subcategories.find(s => s.id === key).groups;
      }
      return sId === 'axle-configurations' && key === 'cabs-ext' ?
        activeCat.subcategories.find(s => s.id === key).variants.filter(ac => ac.name !== 'cab-xxl') :
        activeCat.subcategories.find(s => s.id === key).variants;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/import-button/import-button.component.ts